import { FullStatsV3, UserEventV2 } from "@xapp/stentor-api-client/dist/StentorClient";

import { UserAnalyticsTime } from "routes/App/modules/state";

/**
 * Distills a range of stats into a single # of sessions
 *
 * @export
 * @param {FullStats[]} stats
 * @returns {number}
 */
export function calculateTotals(stats: FullStatsV3[]): UserEventV2 {
    const totals: UserEventV2 = {
        newUsers: 0,
        returningUsers: 0,
        totalSessions: 0,
        totalUsers: 0
    };

    stats.forEach((stat: FullStatsV3) => {
        totals.newUsers = totals.newUsers + stat.total.newUsers;
        totals.returningUsers = totals.returningUsers + stat.total.returningUsers;
        totals.totalSessions = totals.totalSessions + stat.total.totalSessions;
        totals.totalUsers = totals.totalUsers + stat.total.totalUsers;
    });

    return totals;
}

/**
 * Distills a single app's stats out of a collection of many Apps
 *
 * @export
 * @param {UserAnalyticsTime[]} userAnalytics
 * @param {string} appId
 * @returns {UserEventV2}
 */
export function calculateTotalsFromUserAnalytics(userAnalytics: UserAnalyticsTime[], appId: string): UserEventV2 {
    const totals: UserEventV2 = {
        newUsers: 0,
        returningUsers: 0,
        totalSessions: 0,
        totalUsers: 0
    };

    userAnalytics.forEach((ua: UserAnalyticsTime) => {
        const stat = ua.apps[appId] || {
            newUsers: 0,
            returningUsers: 0,
            totalSessions: 0,
            totalUsers: 0
        };

        totals.newUsers = totals.newUsers + stat.newUsers;
        totals.returningUsers = totals.returningUsers + stat.returningUsers;
        totals.totalSessions = totals.totalSessions + stat.totalSessions;
        totals.totalUsers = totals.totalUsers + stat.totalUsers;
    });

    return totals;
}
